import styled from 'styled-components'

import { Theme } from '@/styles/themes'

export const Text = styled.div<{
  color: keyof Theme['colors']
  weight: keyof Theme['fontWeights']
  size: keyof Theme['fontSizes']
  family: keyof Theme['fontFamily']
  hasOnClick?: boolean
  align: string
  lineHeight: keyof Theme['lineHeight']
}>`
  color: ${(props) => props.theme.colors[props.color]};

  font-weight: ${(props) => props.theme.fontWeights[props.weight]};
  font-size: ${(props) => props.theme.fontSizes[props.size]};
  font-family: ${(props) => props.theme.fontFamily[props.family]}, sans-serif;
  line-height: ${(props) => props.theme.lineHeight[props.lineHeight] || '48px'};

  text-align: ${(props) => props.align};

  cursor: ${(props) => (props.hasOnClick ? 'pointer' : 'default')};
`
